<template>
  <div> 
    <div v-if="!qualified_for_approvals"
      class=""
      style="max-width: 500px; margin: auto; margin-top: 50px"
    >
      <article class="tile is-child box">
        <div class="content">
          <div id="check" />
          <div class="icon_container" v-if="!app_status_declined">
            <svg width="91" height="91" viewBox="0 0 91 91" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="45.5" cy="45.5" r="42.5" stroke="url(#paint0_linear_3649_315)" stroke-width="6"/>
              <rect x="11" y="11" width="69" height="69" rx="34.5" fill="#79CA7D"/>
              <path d="M39.9009 52.7471L59.3228 33.3252C59.7811 32.8669 60.3158 32.6377 60.9269 32.6377C61.538 32.6377 62.0728 32.8669 62.5311 33.3252C62.9894 33.7835 63.2186 34.3282 63.2186 34.9592C63.2186 35.5901 62.9894 36.134 62.5311 36.5908L41.5051 57.6742C41.0467 58.1325 40.512 58.3617 39.9009 58.3617C39.2898 58.3617 38.7551 58.1325 38.2967 57.6742L28.4426 47.82C27.9842 47.3617 27.7642 46.8178 27.7826 46.1883C27.8009 45.5589 28.04 45.0142 28.4998 44.5544C28.9597 44.0945 29.5044 43.8653 30.1338 43.8669C30.7632 43.8684 31.3071 44.0976 31.7655 44.5544L39.9009 52.7471Z" fill="white"/>
              <defs>
                <linearGradient id="paint0_linear_3649_315" x1="10" y1="75" x2="91" y2="23" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#85C995"/>
                  <stop offset="1" stop-color="#28A745"/>
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div class="icon_container" v-if="app_status_declined">
            <svg width="91" height="91" viewBox="0 0 91 91" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="45.5" cy="45.5" r="42.5" stroke="url(#paint0_linear_3649_304)" stroke-width="6"/>
              <rect x="11" y="11" width="69" height="69" rx="34.5" fill="#A7C0EA"/>
              <path d="M34 34L57 57M34 57L57 34" stroke="white" stroke-width="3.4375" stroke-linecap="round" stroke-linejoin="round"/>
              <defs>
                <linearGradient id="paint0_linear_3649_304" x1="10" y1="75" x2="91" y2="23" gradientUnits="userSpaceOnUse">
                <stop stop-color="#8FB3EC"/>
                <stop offset="1" stop-color="#2C4CA3"/>
                </linearGradient>
              </defs>
            </svg>
          </div>
          <h2 style="text-align: center; margin-top: 0px;margin-bottom: 49px;"  v-if="!app_status_declined">Great news you're qualified!</h2>
          <h2 style="text-align: center; margin-top: 0px;margin-bottom: 18px;"  v-if="app_status_declined">Bummer!</h2>
          <!-- <p class="subtitle_approval"  v-if="app_status_declined">
            We’ve reviewed your application unfortunately, we’re not able to offer you a loan at this time, We encourage you to <span class="cardiff_word">apply again in 3 months</span>
          </p>
          <p class="subtitle_approval"  v-if="show_sms_optin && !app_status_declined">
              You’ll receive a qualification <span class="cardiff_word">confirmation via SMS and/or email.</span> Your Cardiff Account Manager will guide you through the funding process.
          </p>
          <p class="subtitle_approval"  v-if="!show_sms_optin && !app_status_declined">
              Your Cardiff Account Manager will guide you through the funding process.
          </p> -->
          <br/>
          <div style="width: 100%;text-align: center;margin-bottom: 32px;">
            <div id="summary_table">
              <div class="summary_row border" style="padding-top: 12px;">
                <div style="width: 88px;padding-top: 2px;" class="left_column">DATE</div>
                <div style="width: 146px;" class="right_column"> {{ current_date }}</div>
                <!-- <hr class="summary_divider"> -->
              </div>
              <div class="summary_row border" >
                <div style="width: 160px;" class="left_column">REQUESTED AMOUNT</div>
                <div class="right_column"> {{ requested_amount  }}</div>
                <!-- <hr class="summary_divider"> -->
              </div>
              <div class="summary_row" style="padding-bottom: 12px;">
                <div style="width: 155px;height: 27px;padding-top: 6px;" class="left_column">STATUS</div>
                <div class="right_column prequalified_status"  id="status_pending" v-if="!app_status_declined">Pre-Qualified</div>
                <div class="right_column declined_status " id="status_pending" v-if="app_status_declined">Declined</div>
              </div>
            </div>
          </div>
          <!-- <div id="decline-message" v-if="app_status_declined">
            Your Application did not meet our requirement for one of the following reasons: Business tenure, business revenue or business/personal credit. 
          </div> -->
          <div style="width: 100%;text-align: center;margin-bottom: 32px;">
            <div class="show-video-link" v-if="!app_status_declined" @click="showVideoModal"> 
              <img
                :src="require('@/assets/img/thumbnail_mobile.png')"
                id=""
                height="135"
                width="270"
                defer
              />
            </div>
            <div class="show-video-link"  v-if="app_status_declined" @click="showVideoModal"> 
               <img
                :src="require('@/assets/img/thumbnail_mobile.png')"
                id=""
                height="135"
                width="270"
                defer
              />
            </div>
          </div>
          <div id="cardiff-logo-2004">
            <svg xmlns="http://www.w3.org/2000/svg" width="208" height="28" viewBox="0 0 208 28" fill="none">
              <g clip-path="url(#clip0_3933_582)">
                <path d="M92.0907 0H91.3911V27.97H92.0907V0Z" fill="#B7B9BB"/>
                <path d="M73.7705 22.6086V14.823H72.1986V11.3622H73.7705V9.98367C73.7623 9.24708 73.8775 8.5146 74.1121 7.81915C74.3178 7.20601 74.6347 6.64225 75.0544 6.15256C75.4536 5.69167 75.9556 5.32955 76.5153 5.08676C77.1243 4.83162 77.7786 4.70406 78.437 4.71229C79.6468 4.74109 80.8443 4.988 81.9718 5.43654L81.1982 8.92199C80.9101 8.81911 80.618 8.74092 80.3176 8.6792C80.0418 8.61747 79.762 8.58455 79.4822 8.58044C78.7415 8.58044 78.3711 8.99194 78.3711 9.81495V11.3663H81.1529V14.8271H78.3711V22.6128H73.7746L73.7705 22.6086ZM63.9808 22.6086V14.823H62.4089V11.3622H63.9808V9.98367C63.9685 9.24708 64.0878 8.5146 64.3224 7.81915C64.524 7.20601 64.845 6.64225 65.2647 6.15256C65.668 5.69167 66.1659 5.32955 66.7297 5.08676C67.3387 4.83162 67.993 4.70406 68.6514 4.71229C69.8612 4.74109 71.0587 4.988 72.1862 5.43654L71.4126 8.92199C71.1245 8.81911 70.8324 8.74092 70.532 8.6792C70.2563 8.61747 69.9764 8.58455 69.6966 8.58044C68.9559 8.58044 68.5855 8.99194 68.5855 9.81495V11.3663H71.3673V14.8271H68.5814V22.6128H63.9849L63.9808 22.6086ZM55.9729 9.88491H60.5653V22.6086H55.9729V9.88491ZM55.9729 8.82322V4.95919H60.5653V8.82734H55.9729V8.82322ZM46.175 18.9833C47.0762 18.9504 47.8992 18.4566 48.3518 17.6747V15.3991C48.1461 14.8641 47.8045 14.395 47.3601 14.0329C46.9774 13.7037 46.4877 13.5185 45.9816 13.5144C45.6565 13.5144 45.3396 13.5843 45.0516 13.7325C44.7676 13.8765 44.5207 14.0823 44.3273 14.3374C44.1175 14.6049 43.957 14.9094 43.8418 15.2304C43.7183 15.5801 43.6566 15.9505 43.6607 16.3208C43.6237 17.0328 43.8747 17.7282 44.3479 18.2549C44.8252 18.7446 45.4919 19.0121 46.175 18.9792V18.9833ZM44.9158 22.8514C44.0887 22.8597 43.2698 22.6951 42.5085 22.3659C41.7883 22.049 41.1382 21.584 40.6114 20.9997C40.0641 20.3865 39.6403 19.6705 39.3646 18.8969C39.0601 18.0409 38.9078 17.1356 38.916 16.2262C38.9037 15.3373 39.0436 14.4567 39.3234 13.6173C39.5744 12.856 39.9613 12.1441 40.4715 11.5227C40.9489 10.9425 41.5497 10.4734 42.2245 10.1442C42.9241 9.80672 43.6977 9.638 44.4755 9.64623C45.2656 9.638 46.0433 9.8273 46.7387 10.2018C47.4095 10.5598 47.9609 11.1071 48.3272 11.7737V4.95508H52.9196V17.5348C52.8866 17.8558 52.973 18.1809 53.1623 18.4401C53.4051 18.6417 53.7138 18.7487 54.0306 18.7446V22.6128C53.5615 22.6951 53.1541 22.7527 52.7961 22.7938C52.4834 22.8309 52.1665 22.8514 51.8538 22.8555C50.29 22.8555 49.3847 22.2671 49.146 21.0902L49.0473 20.6293C48.6522 21.3659 48.035 21.9585 47.2819 22.3247C46.5412 22.6786 45.7306 22.8597 44.9117 22.8514H44.9158ZM38.1218 13.8066C37.307 13.7983 36.4923 13.8971 35.7022 14.0987C35.0726 14.2345 34.5006 14.572 34.085 15.0658V22.6128H29.4885V9.88902H33.6982V12.3087C34.0891 11.5227 34.6652 10.8478 35.3771 10.3376C36.0108 9.88902 36.768 9.65035 37.5416 9.65035C37.735 9.64623 37.9284 9.65035 38.1218 9.67504V13.8107V13.8066ZM19.8839 19.5635C20.172 19.5635 20.4559 19.5182 20.7316 19.4318C21.0073 19.3495 21.2666 19.2343 21.5053 19.0779C21.6699 18.9627 21.818 18.8187 21.9415 18.6582C22.0484 18.5224 22.1061 18.3578 22.1102 18.185V17.2426C21.818 17.1397 21.5217 17.0616 21.2172 16.9998C20.9291 16.9381 20.6411 16.9052 20.3489 16.9011C19.851 16.8805 19.3572 17.0245 18.9457 17.3085C18.5959 17.5389 18.386 17.9298 18.386 18.3496C18.3778 18.6911 18.5342 19.0121 18.8099 19.2178C19.1185 19.4524 19.5012 19.5717 19.888 19.5594H19.8839V19.5635ZM18.5054 22.8555C17.9005 22.8555 17.3038 22.7527 16.74 22.5387C16.2174 22.3453 15.736 22.0531 15.3244 21.6786C14.9294 21.3124 14.6125 20.8721 14.3944 20.3824C14.1681 19.8721 14.0488 19.3207 14.0529 18.7652C14.0447 18.152 14.1846 17.5471 14.4603 16.9998C14.736 16.4649 15.1228 15.9958 15.596 15.6213C16.1145 15.218 16.6989 14.9135 17.3244 14.7283C18.0404 14.5102 18.7893 14.4073 19.5383 14.4115C20.4189 14.3827 21.2954 14.5473 22.1019 14.897V14.5102C22.1431 14.0082 21.9497 13.5185 21.5834 13.1769C21.0896 12.8436 20.4971 12.6914 19.9045 12.7408C19.2173 12.7325 18.5383 12.8519 17.8964 13.0946C17.2174 13.3621 16.5672 13.7078 15.9623 14.1234L14.629 11.2717C16.3409 10.1812 18.3367 9.61743 20.3613 9.65446C22.0361 9.54747 23.6945 10.0248 25.0524 11.0083C26.2046 12.033 26.8096 13.5391 26.6984 15.074V17.543C26.6655 17.864 26.7519 18.1891 26.9412 18.4483C27.184 18.65 27.4927 18.757 27.8095 18.7528V22.621C27.3898 22.7033 26.9947 22.7609 26.6244 22.8021C26.2952 22.8391 25.9619 22.8597 25.6327 22.8638C24.9784 22.909 24.3241 22.7527 23.7603 22.4152C23.3241 22.0984 23.0237 21.6251 22.9249 21.0943L22.8262 20.6334C22.3036 21.3247 21.6328 21.8885 20.8674 22.2877C20.1349 22.6621 19.3243 22.8597 18.4972 22.8555V22.8473L18.5054 22.8555ZM0 16.2509C0 15.395 0.152257 14.5473 0.456771 13.7489C0.753054 12.963 1.21394 12.2469 1.80239 11.6461C2.42376 11.0165 3.16859 10.5227 3.9916 10.1935C4.94629 9.81495 5.96682 9.62978 6.99147 9.65035C8.34944 9.60097 9.69506 9.9384 10.872 10.6174C11.8678 11.2141 12.6785 12.0782 13.2093 13.1111L8.73214 14.4691C8.34944 13.8683 7.67868 13.5062 6.96678 13.5226C6.35775 13.5144 5.77342 13.7777 5.37014 14.2345C4.90514 14.8024 4.67058 15.5225 4.71996 16.255C4.67058 16.9875 4.90514 17.7076 5.37014 18.2755C5.77342 18.7364 6.35775 18.9956 6.96678 18.9874C7.67868 19.0039 8.34944 18.6459 8.73214 18.0451L13.2093 19.403C12.6785 20.4359 11.8678 21.3001 10.872 21.8967C9.69506 22.5757 8.34944 22.9132 6.99147 22.8638C5.96682 22.8844 4.94629 22.6992 3.9916 22.3206C3.16859 21.9914 2.42376 21.4976 1.80239 20.868C1.21806 20.2631 0.761284 19.547 0.460886 18.7611C0.152257 17.9669 0 17.1151 0 16.2591V16.2509Z" fill="#3D4A9F"/>
                <path d="M101.51 12.0033H102.633V9.02816H105.674V8.06523H102.633V6.05297H106.51V5.08594H101.51V12.0033Z" fill="#797B7D"/>
                <path d="M108.324 4.48828C108.082 4.48828 107.892 4.54589 107.765 4.66523C107.637 4.78457 107.571 4.95328 107.571 5.17961C107.571 5.40594 107.637 5.57465 107.765 5.69811C107.892 5.82156 108.082 5.88328 108.324 5.88328C108.567 5.88328 108.744 5.82156 108.876 5.69811C109.003 5.57465 109.069 5.40182 109.069 5.17961C109.069 4.9574 109.003 4.78457 108.876 4.66523C108.748 4.54589 108.563 4.48828 108.324 4.48828Z" fill="#797B7D"/>
                <path d="M108.88 6.75977H107.756V12.0023H108.88V6.75977Z" fill="#797B7D"/>
                <path d="M114.451 6.87511C114.155 6.73109 113.822 6.66113 113.451 6.66113C113.163 6.66113 112.892 6.7064 112.641 6.79693C112.386 6.88746 112.168 7.03149 111.982 7.23312C111.859 7.36481 111.764 7.52529 111.682 7.69813L111.633 6.76401H110.637V12.0066H111.76V9.22069C111.76 8.82153 111.83 8.50468 111.974 8.266C112.118 8.02733 112.295 7.8545 112.513 7.74751C112.731 7.64051 112.953 7.58702 113.184 7.58702C113.505 7.58702 113.772 7.68578 113.986 7.88742C114.2 8.08494 114.307 8.44295 114.307 8.96145V12.0107H115.431V8.61578C115.431 8.17547 115.344 7.81335 115.167 7.52529C114.995 7.23724 114.756 7.02326 114.46 6.87923L114.451 6.87511Z" fill="#797B7D"/>
                <path d="M121.258 10.8628V8.52546C121.258 8.09749 121.163 7.74771 120.978 7.47612C120.793 7.20453 120.538 6.99878 120.217 6.86298C119.896 6.72718 119.525 6.65723 119.106 6.65723C118.492 6.65723 117.99 6.78479 117.604 7.04404C117.217 7.30329 116.957 7.64484 116.822 8.0728L117.764 8.47196C117.867 8.14276 118.032 7.90409 118.258 7.76006C118.484 7.61603 118.752 7.54196 119.064 7.54196C119.402 7.54196 119.665 7.63661 119.854 7.83002C120.048 8.02342 120.143 8.29502 120.143 8.64068V8.84232L118.278 9.20856C117.809 9.29909 117.447 9.47192 117.192 9.72294C116.937 9.97396 116.809 10.2949 116.809 10.6859C116.809 10.9986 116.883 11.2661 117.036 11.476C117.188 11.6858 117.394 11.8463 117.653 11.9533C117.916 12.0603 118.213 12.1097 118.538 12.1097C118.805 12.1097 119.064 12.0644 119.324 11.978C119.583 11.8916 119.809 11.7558 120.007 11.5788C120.085 11.5089 120.151 11.4266 120.208 11.3402C120.233 11.4348 120.27 11.5253 120.315 11.5994C120.414 11.764 120.554 11.8875 120.735 11.9656C120.916 12.0438 121.114 12.085 121.336 12.085C121.579 12.085 121.784 12.0479 121.945 11.9698L122.007 11.1961C121.887 11.2332 121.764 11.2496 121.64 11.2496C121.381 11.2496 121.254 11.1221 121.254 10.8628H121.258ZM120.036 10.6036C119.961 10.7558 119.859 10.8752 119.727 10.9698C119.595 11.0644 119.447 11.1303 119.282 11.1756C119.118 11.2167 118.949 11.2373 118.776 11.2373C118.525 11.2373 118.324 11.1797 118.176 11.0644C118.027 10.9492 117.949 10.7929 117.949 10.5994C117.949 10.406 118.023 10.2414 118.171 10.1386C118.32 10.0357 118.538 9.95338 118.83 9.89577L120.151 9.62418V10.0645C120.151 10.2744 120.114 10.4554 120.04 10.6036H120.036Z" fill="#797B7D"/>
                <path d="M126.912 6.87511C126.616 6.73109 126.282 6.66113 125.912 6.66113C125.624 6.66113 125.352 6.7064 125.101 6.79693C124.846 6.88746 124.628 7.03149 124.443 7.23312C124.319 7.36481 124.225 7.52529 124.142 7.69813L124.093 6.76401H123.097V12.0066H124.221V9.22069C124.221 8.82153 124.291 8.50468 124.435 8.266C124.579 8.02733 124.756 7.8545 124.974 7.74751C125.192 7.64051 125.414 7.58702 125.644 7.58702C125.965 7.58702 126.233 7.68578 126.447 7.88742C126.661 8.08494 126.768 8.44295 126.768 8.96145V12.0107H127.891V8.61578C127.891 8.17547 127.805 7.81335 127.628 7.52529C127.455 7.23724 127.216 7.02326 126.92 6.87923L126.912 6.87511Z" fill="#797B7D"/>
                <path d="M132.908 10.749C132.793 10.9012 132.649 11.0165 132.472 11.0946C132.295 11.1728 132.089 11.214 131.854 11.214C131.546 11.214 131.282 11.144 131.056 11.0041C130.83 10.8642 130.661 10.6585 130.542 10.3869C130.422 10.1153 130.365 9.78194 130.365 9.39101C130.365 9.00008 130.422 8.65854 130.538 8.38283C130.653 8.10712 130.821 7.90137 131.048 7.75734C131.274 7.61331 131.542 7.54336 131.854 7.54336C132.167 7.54336 132.435 7.62977 132.636 7.79849C132.834 7.97132 132.978 8.21823 133.072 8.5392L134.13 8.11946C134.027 7.83141 133.871 7.57628 133.669 7.35406C133.467 7.13185 133.216 6.95902 132.92 6.83557C132.624 6.71212 132.266 6.65039 131.846 6.65039C131.344 6.65039 130.896 6.75738 130.5 6.97548C130.105 7.19358 129.797 7.50632 129.579 7.91371C129.357 8.3211 129.25 8.81079 129.25 9.37455C129.25 9.93832 129.361 10.428 129.579 10.8354C129.797 11.2428 130.11 11.5555 130.505 11.7736C130.9 11.9917 131.361 12.0987 131.879 12.0987C132.278 12.0987 132.628 12.0329 132.937 11.9053C133.245 11.7777 133.5 11.5926 133.706 11.3621C133.912 11.1276 134.064 10.8519 134.163 10.5391L133.146 10.1934C133.105 10.4115 133.027 10.5926 132.912 10.7449L132.908 10.749Z" fill="#797B7D"/>
                <path d="M136.035 4.48828C135.792 4.48828 135.603 4.54589 135.475 4.66523C135.348 4.78457 135.282 4.95328 135.282 5.17961C135.282 5.40594 135.348 5.57465 135.475 5.69811C135.603 5.82156 135.792 5.88328 136.035 5.88328C136.278 5.88328 136.455 5.82156 136.586 5.69811C136.714 5.57465 136.78 5.40182 136.78 5.17961C136.78 4.9574 136.714 4.78457 136.586 4.66523C136.459 4.54589 136.274 4.48828 136.035 4.48828Z" fill="#797B7D"/>
                <path d="M136.59 6.75977H135.467V12.0023H136.59V6.75977Z" fill="#797B7D"/>
                <path d="M142.163 6.87511C141.866 6.73109 141.533 6.66113 141.163 6.66113C140.875 6.66113 140.607 6.7064 140.352 6.79693C140.097 6.88746 139.879 7.03149 139.694 7.23312C139.57 7.36481 139.475 7.52529 139.393 7.69813L139.344 6.76401H138.348V12.0066H139.471V9.22069C139.471 8.82153 139.541 8.50468 139.685 8.266C139.829 8.02733 140.01 7.8545 140.224 7.74751C140.438 7.64051 140.665 7.58702 140.895 7.58702C141.216 7.58702 141.484 7.68578 141.698 7.88742C141.912 8.08494 142.019 8.44295 142.019 8.96145V12.0107H143.142V8.61578C143.142 8.17547 143.056 7.81335 142.879 7.52529C142.706 7.23724 142.467 7.02326 142.171 6.87923L142.163 6.87511Z" fill="#797B7D"/>
                <path d="M149.442 5.65744H149.36C149.08 5.65744 148.829 5.71916 148.611 5.84673C148.388 5.97429 148.22 6.14713 148.1 6.36522C148.018 6.51748 147.977 6.6862 147.952 6.86315C147.619 6.72323 147.228 6.65328 146.779 6.65328C146.331 6.65328 145.94 6.72735 145.598 6.87137C145.261 7.01952 144.998 7.22527 144.808 7.48863C144.619 7.75611 144.524 8.06474 144.524 8.42275C144.524 8.95359 144.718 9.38156 145.105 9.70665C145.179 9.76837 145.269 9.82187 145.356 9.87536C145.183 9.93709 145.031 10.0235 144.907 10.1346C144.677 10.3445 144.561 10.5996 144.561 10.9C144.561 11.2004 144.652 11.4309 144.829 11.5955C144.932 11.6901 145.059 11.7642 145.199 11.8259C144.932 11.8835 144.722 11.9823 144.586 12.1263C144.389 12.3362 144.29 12.579 144.29 12.8588C144.29 13.2579 144.496 13.5871 144.907 13.8546C145.319 14.1221 145.956 14.2538 146.812 14.2538C147.323 14.2538 147.775 14.1838 148.17 14.0439C148.565 13.904 148.878 13.7024 149.109 13.4431C149.339 13.1839 149.454 12.867 149.454 12.5049C149.454 12.0934 149.306 11.7683 149.014 11.5337C148.722 11.2992 148.31 11.1839 147.775 11.1839H146.203C145.965 11.1839 145.784 11.1428 145.652 11.0564C145.524 10.9741 145.458 10.8424 145.458 10.6696C145.458 10.5214 145.524 10.3897 145.656 10.2704C145.734 10.2005 145.845 10.1511 145.985 10.1099C146.22 10.1634 146.479 10.1963 146.767 10.1963C147.228 10.1963 147.627 10.1223 147.969 9.97412C148.306 9.82598 148.569 9.62023 148.755 9.35687C148.94 9.0935 149.03 8.78076 149.03 8.42275C149.03 8.06474 148.936 7.75611 148.755 7.48863C148.676 7.37341 148.578 7.27465 148.471 7.18412C148.504 6.99894 148.582 6.8508 148.718 6.73969C148.895 6.59567 149.146 6.52571 149.483 6.52571C149.504 6.52571 149.524 6.52571 149.545 6.52983C149.565 6.53394 149.586 6.53394 149.606 6.53394L149.429 5.65332L149.442 5.65744ZM145.928 12.1057H147.615C147.952 12.1057 148.183 12.1551 148.31 12.2539C148.438 12.3526 148.504 12.4802 148.504 12.6407C148.504 12.7806 148.442 12.9082 148.318 13.0234C148.195 13.1386 148.01 13.2332 147.763 13.3073C147.516 13.3814 147.199 13.4184 146.812 13.4184C146.314 13.4184 145.928 13.3526 145.648 13.2209C145.368 13.0892 145.228 12.9082 145.228 12.6777C145.228 12.5049 145.294 12.365 145.426 12.2621C145.557 12.1592 145.722 12.1098 145.919 12.1098L145.928 12.1057ZM147.59 9.15111C147.376 9.33218 147.104 9.42271 146.779 9.42271C146.454 9.42271 146.191 9.33218 145.977 9.15111C145.763 8.97005 145.656 8.72726 145.656 8.42686C145.656 8.12647 145.763 7.88779 145.977 7.71085C146.191 7.5339 146.458 7.44337 146.779 7.44337C147.1 7.44337 147.38 7.5339 147.59 7.71085C147.804 7.88779 147.911 8.13058 147.911 8.42686C147.911 8.72315 147.804 8.97005 147.59 9.15111Z" fill="#797B7D"/>
                <path d="M155.174 8.99091H158.211V8.04857H155.174V6.05688H159.063V5.08984H154.051V12.0072H159.207V11.0443H155.174V8.99091Z" fill="#797B7D"/>
                <path d="M165.161 6.76855H163.873L162.626 8.66148L161.38 6.76855H160.026L161.898 9.36515L159.919 12.007H161.198L162.548 10.0441L163.861 12.007H165.194L163.281 9.34046L165.161 6.76855Z" fill="#797B7D"/>
                <path d="M169.42 10.7578C169.305 10.91 169.161 11.0252 168.984 11.1034C168.807 11.1816 168.601 11.2228 168.367 11.2228C168.058 11.2228 167.795 11.1528 167.568 11.0129C167.342 10.873 167.173 10.6672 167.054 10.3956C166.935 10.1241 166.877 9.79073 166.877 9.3998C166.877 9.00887 166.935 8.66732 167.05 8.39162C167.165 8.11591 167.334 7.91016 167.56 7.76613C167.787 7.6221 168.054 7.55215 168.367 7.55215C168.68 7.55215 168.947 7.63856 169.149 7.80728C169.346 7.98011 169.49 8.22701 169.585 8.54799L170.642 8.12825C170.54 7.8402 170.383 7.58507 170.182 7.36285C169.98 7.14064 169.729 6.96781 169.433 6.84436C169.136 6.72091 168.778 6.65918 168.359 6.65918C167.857 6.65918 167.408 6.76617 167.013 6.98427C166.618 7.20237 166.309 7.51511 166.091 7.9225C165.869 8.32989 165.762 8.81958 165.762 9.38334C165.762 9.94711 165.873 10.4368 166.091 10.8442C166.309 11.2516 166.622 11.5643 167.017 11.7824C167.412 12.0005 167.873 12.1075 168.391 12.1075C168.791 12.1075 169.14 12.0417 169.449 11.9141C169.758 11.7865 170.013 11.6014 170.219 11.3709C170.424 11.1364 170.577 10.8606 170.675 10.5479L169.659 10.2022C169.618 10.4203 169.54 10.6014 169.424 10.7537L169.42 10.7578Z" fill="#797B7D"/>
                <path d="M175.527 6.97583C175.174 6.76596 174.737 6.66309 174.227 6.66309C173.717 6.66309 173.289 6.77008 172.898 6.98817C172.507 7.20627 172.203 7.51902 171.98 7.92641C171.758 8.3338 171.651 8.82349 171.651 9.38725C171.651 9.95101 171.762 10.4407 171.98 10.8481C172.198 11.2555 172.511 11.5682 172.906 11.7863C173.301 12.0044 173.766 12.1114 174.289 12.1114C174.639 12.1114 174.96 12.062 175.252 11.9633C175.544 11.8645 175.799 11.7246 176.013 11.5394C176.227 11.3542 176.396 11.1361 176.523 10.8851L175.63 10.4654C175.507 10.7041 175.334 10.8892 175.116 11.0209C174.898 11.1526 174.614 11.2184 174.268 11.2184C173.956 11.2184 173.68 11.1485 173.449 11.0086C173.219 10.8687 173.042 10.6629 172.914 10.3913C172.824 10.1979 172.77 9.97159 172.742 9.72057H176.581C176.593 9.63827 176.606 9.53951 176.614 9.4284C176.622 9.31729 176.622 9.19796 176.622 9.07039C176.622 8.60951 176.527 8.198 176.338 7.83176C176.149 7.46552 175.877 7.18158 175.519 6.97171L175.527 6.97583ZM172.906 8.38318C173.026 8.10747 173.194 7.8976 173.421 7.75769C173.643 7.61778 173.906 7.54782 174.207 7.54782C174.618 7.54782 174.943 7.67539 175.182 7.93052C175.392 8.15273 175.503 8.46548 175.527 8.85641H172.77C172.799 8.67946 172.844 8.52309 172.906 8.37906V8.38318Z" fill="#797B7D"/>
                <path d="M179.72 11.2208C179.511 11.2208 179.362 11.1714 179.272 11.0726C179.181 10.9739 179.136 10.7969 179.136 10.5377V4.40625H178.013V10.6323C178.013 11.1344 178.124 11.5088 178.342 11.7475C178.56 11.9903 178.906 12.1096 179.375 12.1096C179.527 12.1096 179.683 12.0932 179.836 12.0644C179.988 12.0314 180.128 11.9903 180.243 11.9327L180.371 11.0932C180.239 11.1426 180.128 11.1755 180.041 11.192C179.955 11.2084 179.848 11.2167 179.72 11.2167V11.2208Z" fill="#797B7D"/>
                <path d="M182.988 11.2208C182.778 11.2208 182.63 11.1714 182.535 11.0726C182.445 10.9739 182.4 10.7969 182.4 10.5377V4.40625H181.276V10.6323C181.276 11.1344 181.387 11.5088 181.605 11.7475C181.828 11.9903 182.169 12.1096 182.638 12.1096C182.79 12.1096 182.947 12.0932 183.099 12.0644C183.251 12.0356 183.387 11.9903 183.506 11.9327L183.63 11.0932C183.498 11.1426 183.387 11.1755 183.301 11.192C183.214 11.2084 183.107 11.2167 182.98 11.2167L182.988 11.2208Z" fill="#797B7D"/>
                <path d="M188.123 6.97583C187.77 6.76596 187.333 6.66309 186.823 6.66309C186.313 6.66309 185.885 6.77008 185.494 6.98817C185.103 7.20627 184.798 7.51902 184.576 7.92641C184.354 8.3338 184.247 8.82349 184.247 9.38725C184.247 9.95101 184.358 10.4407 184.576 10.8481C184.794 11.2555 185.107 11.5682 185.502 11.7863C185.897 12.0044 186.362 12.1114 186.885 12.1114C187.235 12.1114 187.556 12.062 187.848 11.9633C188.14 11.8645 188.395 11.7246 188.609 11.5394C188.823 11.3542 188.992 11.1361 189.119 10.8851L188.226 10.4654C188.103 10.7041 187.93 10.8892 187.712 11.0209C187.494 11.1526 187.21 11.2184 186.864 11.2184C186.552 11.2184 186.276 11.1485 186.045 11.0086C185.815 10.8687 185.638 10.6629 185.51 10.3913C185.42 10.1979 185.366 9.97159 185.338 9.72057H189.177C189.189 9.63827 189.202 9.53951 189.21 9.4284C189.218 9.31729 189.218 9.19796 189.218 9.07039C189.218 8.60951 189.123 8.198 188.934 7.83176C188.745 7.46552 188.473 7.18158 188.115 6.97171L188.123 6.97583ZM185.506 8.38318C185.626 8.10747 185.794 7.8976 186.021 7.75769C186.243 7.61778 186.506 7.54782 186.807 7.54782C187.218 7.54782 187.543 7.67539 187.782 7.93052C187.992 8.15273 188.103 8.46548 188.128 8.85641H185.37C185.399 8.67946 185.445 8.52309 185.506 8.37906V8.38318Z" fill="#797B7D"/>
                <path d="M194.46 6.87707C194.164 6.73304 193.831 6.66309 193.46 6.66309C193.172 6.66309 192.901 6.70835 192.65 6.79888C192.395 6.88941 192.177 7.03344 191.991 7.23508C191.868 7.36676 191.773 7.52725 191.691 7.70008L191.642 6.76596H190.646V12.0085H191.769V9.22265C191.769 8.82349 191.839 8.50663 191.983 8.26796C192.127 8.02928 192.304 7.85645 192.522 7.74946C192.74 7.64247 192.963 7.58897 193.193 7.58897C193.514 7.58897 193.781 7.68773 193.995 7.88937C194.209 8.08689 194.316 8.4449 194.316 8.9634V12.0127H195.44V8.61774C195.44 8.17742 195.353 7.8153 195.176 7.52725C195.004 7.23919 194.765 7.02521 194.469 6.88118L194.46 6.87707Z" fill="#797B7D"/>
                <path d="M200.457 10.7578C200.341 10.91 200.197 11.0252 200.02 11.1034C199.843 11.1816 199.638 11.2228 199.403 11.2228C199.095 11.2228 198.831 11.1528 198.605 11.0129C198.378 10.873 198.21 10.6672 198.09 10.3956C197.971 10.1241 197.913 9.79073 197.913 9.3998C197.913 9.00887 197.971 8.66732 198.086 8.39162C198.202 8.11591 198.37 7.91016 198.592 7.76613C198.815 7.6221 199.086 7.55215 199.399 7.55215C199.712 7.55215 199.979 7.63856 200.181 7.80728C200.378 7.98011 200.527 8.22701 200.617 8.54799L201.675 8.12825C201.568 7.8402 201.415 7.58507 201.214 7.36285C201.012 7.14064 200.761 6.96781 200.465 6.84436C200.169 6.72091 199.811 6.65918 199.391 6.65918C198.889 6.65918 198.44 6.76617 198.045 6.98427C197.65 7.20237 197.341 7.51511 197.123 7.9225C196.901 8.32989 196.794 8.81958 196.794 9.38334C196.794 9.94711 196.905 10.4368 197.123 10.8442C197.341 11.2516 197.654 11.5643 198.049 11.7824C198.448 12.0005 198.905 12.1075 199.42 12.1075C199.819 12.1075 200.173 12.0417 200.477 11.9141C200.786 11.7865 201.041 11.6014 201.247 11.3709C201.452 11.1364 201.605 10.8606 201.703 10.5479L200.687 10.2022C200.646 10.4203 200.568 10.6014 200.452 10.7537L200.457 10.7578Z" fill="#797B7D"/>
                <path d="M207.378 7.83588C207.189 7.47375 206.917 7.1857 206.559 6.97583C206.201 6.76596 205.769 6.66309 205.259 6.66309C204.748 6.66309 204.32 6.77008 203.929 6.98817C203.539 7.20627 203.234 7.51902 203.012 7.92641C202.79 8.3338 202.683 8.82349 202.683 9.38725C202.683 9.95101 202.794 10.4407 203.012 10.8481C203.23 11.2555 203.543 11.5682 203.938 11.7863C204.337 12.0044 204.798 12.1114 205.32 12.1114C205.67 12.1114 205.991 12.062 206.283 11.9633C206.575 11.8645 206.831 11.7246 207.045 11.5394C207.259 11.3542 207.427 11.1361 207.551 10.8851L206.658 10.4654C206.534 10.7041 206.361 10.8892 206.143 11.0209C205.925 11.1526 205.645 11.2184 205.296 11.2184C204.983 11.2184 204.707 11.1485 204.477 11.0086C204.246 10.8687 204.069 10.6629 203.942 10.3913C203.851 10.1979 203.798 9.97159 203.769 9.72057H207.608C207.621 9.63827 207.633 9.53951 207.641 9.4284C207.649 9.31729 207.649 9.19796 207.649 9.07039C207.649 8.60951 207.555 8.198 207.366 7.83176L207.378 7.83588ZM203.942 8.38318C204.061 8.10747 204.23 7.8976 204.456 7.75769C204.678 7.61778 204.942 7.54782 205.242 7.54782C205.654 7.54782 205.979 7.67539 206.217 7.93052C206.427 8.15273 206.538 8.46548 206.563 8.85641H203.81C203.839 8.67946 203.884 8.52309 203.946 8.37906L203.942 8.38318Z" fill="#797B7D"/>
                <path d="M103.839 16.9404C104 16.8828 104.21 16.8581 104.469 16.8581C104.909 16.8581 105.304 16.9363 105.65 17.0927C105.996 17.249 106.321 17.4836 106.621 17.8004L107.489 16.6359C107.127 16.2532 106.699 15.961 106.205 15.7594C105.712 15.5619 105.144 15.459 104.502 15.459C103.86 15.459 103.346 15.5577 102.897 15.7512C102.448 15.9487 102.107 16.2162 101.868 16.5536C101.63 16.891 101.51 17.2778 101.51 17.714C101.51 18.0967 101.597 18.4177 101.774 18.6728C101.946 18.928 102.185 19.1296 102.49 19.2819C102.794 19.4341 103.14 19.5535 103.531 19.644L104.81 19.9279C105.103 19.9979 105.304 20.0843 105.407 20.1831C105.51 20.2859 105.564 20.4094 105.564 20.5534C105.564 20.6851 105.527 20.8003 105.448 20.8991C105.37 20.9978 105.251 21.0719 105.086 21.1172C104.922 21.1666 104.716 21.1913 104.473 21.1913C104.16 21.1913 103.848 21.146 103.547 21.0555C103.247 20.9649 102.963 20.8415 102.708 20.6851C102.453 20.5287 102.239 20.3477 102.062 20.146L101.193 21.3517C101.424 21.5945 101.708 21.8126 102.041 22.0019C102.374 22.1912 102.753 22.3352 103.173 22.4381C103.592 22.541 104.033 22.5904 104.494 22.5904C105.057 22.5904 105.564 22.504 106.004 22.3352C106.444 22.1624 106.79 21.9073 107.041 21.5698C107.292 21.2324 107.419 20.8168 107.419 20.3271C107.419 19.8374 107.259 19.4094 106.938 19.1008C106.617 18.7922 106.111 18.5576 105.42 18.3971L104.255 18.1338C103.946 18.0638 103.724 17.9774 103.588 17.8786C103.453 17.7799 103.383 17.6523 103.383 17.5083C103.383 17.3807 103.42 17.2696 103.49 17.175C103.56 17.0762 103.675 17.0021 103.835 16.9445L103.839 16.9404Z" fill="#3D4A9F"/>
                <path d="M110.189 17.2471H108.407V22.4896H110.189V17.2471Z" fill="#3D4A9F"/>
                <path d="M109.3 14.9287C108.938 14.9287 108.675 14.9987 108.51 15.1345C108.345 15.2703 108.263 15.4884 108.263 15.7888C108.263 16.0892 108.345 16.299 108.51 16.4348C108.675 16.5706 108.938 16.6406 109.3 16.6406C109.662 16.6406 109.917 16.5706 110.086 16.4348C110.255 16.299 110.337 16.085 110.337 15.7888C110.337 15.4925 110.255 15.2703 110.086 15.1345C109.917 14.9987 109.658 14.9287 109.3 14.9287Z" fill="#3D4A9F"/>
                <path d="M115.843 17.3495C115.576 17.2096 115.259 17.1396 114.893 17.1396C114.559 17.1396 114.255 17.2055 113.987 17.3331C113.72 17.4606 113.493 17.654 113.317 17.905C113.234 18.0203 113.164 18.152 113.103 18.296L113.049 17.2425H111.457V22.4851H113.238V19.7074C113.238 19.4153 113.28 19.1807 113.362 19.0038C113.444 18.8309 113.559 18.7034 113.707 18.6211C113.856 18.5429 114.012 18.5017 114.181 18.5017C114.399 18.5017 114.576 18.5717 114.716 18.7116C114.856 18.8515 114.926 19.1025 114.926 19.4647V22.4851H116.707V18.9955C116.707 18.584 116.629 18.2425 116.477 17.9668C116.325 17.6952 116.111 17.4894 115.843 17.3495Z" fill="#3D4A9F"/>
                <path d="M121.225 20.9337C121.147 21.0613 121.053 21.1559 120.937 21.2218C120.822 21.2876 120.678 21.3205 120.501 21.3205C120.291 21.3205 120.11 21.2753 119.958 21.1806C119.806 21.086 119.686 20.9337 119.6 20.7197C119.514 20.5058 119.477 20.2301 119.477 19.8844C119.477 19.5387 119.514 19.2589 119.592 19.0408C119.67 18.8227 119.781 18.6622 119.933 18.5593C120.086 18.4565 120.271 18.4071 120.493 18.4071C120.736 18.4071 120.925 18.4812 121.053 18.6334C121.18 18.7857 121.271 19.0079 121.32 19.3083L122.966 18.7651C122.917 18.477 122.793 18.2096 122.596 17.9627C122.398 17.7158 122.123 17.5141 121.769 17.366C121.415 17.2178 120.974 17.1396 120.444 17.1396C119.913 17.1396 119.419 17.2466 119.003 17.4606C118.588 17.6746 118.263 17.9832 118.032 18.3947C117.802 18.8021 117.687 19.2959 117.687 19.8679C117.687 20.4399 117.802 20.9337 118.032 21.3411C118.263 21.7485 118.592 22.0612 119.016 22.2752C119.44 22.4892 119.942 22.5962 120.514 22.5962C120.983 22.5962 121.39 22.5262 121.74 22.3863C122.09 22.2464 122.369 22.0571 122.583 21.8143C122.797 21.5716 122.929 21.3 122.974 20.9913L121.369 20.477C121.349 20.658 121.3 20.8144 121.221 20.9378L121.225 20.9337Z" fill="#3D4A9F"/>
                <path d="M128.666 18.3412C128.464 17.9668 128.168 17.6746 127.781 17.4606C127.394 17.2466 126.925 17.1396 126.369 17.1396C125.814 17.1396 125.353 17.2466 124.937 17.4647C124.522 17.6828 124.197 17.9915 123.966 18.3989C123.736 18.8062 123.621 19.2918 123.621 19.8679C123.621 20.444 123.736 20.9296 123.966 21.337C124.197 21.7444 124.526 22.053 124.946 22.2711C125.37 22.4892 125.867 22.5962 126.448 22.5962C126.81 22.5962 127.16 22.5427 127.489 22.4398C127.822 22.337 128.106 22.1806 128.349 21.9748C128.592 21.7691 128.76 21.5139 128.859 21.2135L127.435 20.7403C127.357 20.9296 127.242 21.0736 127.085 21.1806C126.929 21.2835 126.715 21.337 126.452 21.337C126.213 21.337 126.011 21.2917 125.843 21.1971C125.674 21.1024 125.546 20.9502 125.456 20.7362C125.407 20.6169 125.369 20.4811 125.349 20.3206H128.925C128.937 20.2383 128.95 20.1313 128.958 20.0078C128.966 19.8844 128.97 19.7568 128.97 19.6293C128.97 19.1478 128.867 18.7198 128.666 18.3454V18.3412ZM125.802 18.547C125.958 18.4441 126.147 18.3906 126.374 18.3906C126.686 18.3906 126.921 18.5017 127.069 18.7239C127.176 18.8844 127.246 19.0984 127.275 19.3618H125.365C125.386 19.2424 125.411 19.1313 125.444 19.0367C125.522 18.8145 125.641 18.6499 125.802 18.5429V18.547Z" fill="#3D4A9F"/>
                <path d="M132.953 22.488V21.1465L133.509 20.8214C133.957 20.5622 134.348 20.3358 134.682 20.1342C135.019 19.9367 135.295 19.7515 135.517 19.5787C135.739 19.4058 135.9 19.2412 136.011 19.0808C136.118 18.9203 136.171 18.7474 136.171 18.5664C136.171 18.3359 136.097 18.1507 135.945 18.015C135.793 17.8792 135.579 17.8092 135.299 17.8092C135.056 17.8092 134.838 17.8792 134.649 18.015C134.459 18.1507 134.311 18.3318 134.208 18.554L132.793 17.9861C133.011 17.5047 133.336 17.1138 133.772 16.8175C134.208 16.5212 134.751 16.373 135.402 16.373C135.723 16.373 136.039 16.4101 136.352 16.4842C136.665 16.5582 136.937 16.6734 137.175 16.8339C137.414 16.9944 137.603 17.2043 137.751 17.4594C137.899 17.7146 137.974 18.0273 137.974 18.3977C137.974 18.7063 137.912 18.9779 137.784 19.2207C137.657 19.4635 137.496 19.6815 137.299 19.8791C137.101 20.0766 136.879 20.2577 136.632 20.4181C136.385 20.5786 136.142 20.7309 135.9 20.879L135.595 21.0683V21.0889H138.068V22.4839H132.953V22.488Z" fill="#3D4A9F"/>
                <path d="M145.426 19.5069C145.426 19.9884 145.34 20.4246 145.171 20.8155C145.002 21.2064 144.768 21.5397 144.467 21.8154C144.171 22.0912 143.821 22.301 143.426 22.4492C143.027 22.5973 142.603 22.6673 142.146 22.6673C141.69 22.6673 141.278 22.5932 140.883 22.4492C140.488 22.3051 140.142 22.0912 139.85 21.8154C139.558 21.5397 139.324 21.2064 139.155 20.8155C138.986 20.4246 138.9 19.9884 138.9 19.5069C138.9 19.0254 138.986 18.5934 139.155 18.2024C139.328 17.8156 139.558 17.4864 139.85 17.2189C140.142 16.9515 140.488 16.7457 140.883 16.6017C141.278 16.4577 141.698 16.3877 142.146 16.3877C142.595 16.3877 143.027 16.4577 143.426 16.6017C143.825 16.7457 144.171 16.9515 144.467 17.2189C144.764 17.4864 144.998 17.8156 145.171 18.2024C145.344 18.5892 145.426 19.0254 145.426 19.5069ZM143.677 19.4987C143.677 19.2765 143.64 19.0666 143.566 18.8691C143.492 18.6715 143.389 18.5028 143.257 18.3629C143.126 18.223 142.965 18.1078 142.776 18.0214C142.587 17.935 142.377 17.8938 142.151 17.8938C141.924 17.8938 141.714 17.935 141.529 18.0214C141.344 18.1078 141.188 18.2189 141.06 18.3629C140.932 18.5069 140.83 18.6757 140.756 18.8691C140.681 19.0666 140.644 19.2765 140.644 19.4987C140.644 19.7209 140.681 19.9431 140.756 20.1365C140.83 20.334 140.928 20.5027 141.06 20.6509C141.188 20.799 141.344 20.9143 141.529 20.9966C141.714 21.0789 141.92 21.1241 142.151 21.1241C142.381 21.1241 142.591 21.083 142.776 20.9966C142.961 20.9101 143.126 20.799 143.257 20.6509C143.389 20.5027 143.492 20.334 143.566 20.1365C143.64 19.939 143.677 19.7291 143.677 19.4987Z" fill="#3D4A9F"/>
                <path d="M152.845 19.5069C152.845 19.9884 152.759 20.4246 152.59 20.8155C152.417 21.2064 152.183 21.5397 151.887 21.8154C151.59 22.0912 151.24 22.301 150.845 22.4492C150.446 22.5973 150.022 22.6673 149.566 22.6673C149.109 22.6673 148.697 22.5932 148.302 22.4492C147.907 22.3051 147.566 22.0912 147.269 21.8154C146.977 21.5397 146.743 21.2064 146.574 20.8155C146.405 20.4246 146.319 19.9884 146.319 19.5069C146.319 19.0254 146.405 18.5934 146.574 18.2024C146.747 17.8156 146.977 17.4864 147.269 17.2189C147.562 16.9515 147.907 16.7457 148.302 16.6017C148.697 16.4577 149.117 16.3877 149.566 16.3877C150.014 16.3877 150.446 16.4577 150.845 16.6017C151.245 16.7457 151.59 16.9515 151.887 17.2189C152.183 17.4864 152.417 17.8156 152.59 18.2024C152.759 18.5892 152.845 19.0254 152.845 19.5069ZM151.096 19.4987C151.096 19.2765 151.059 19.0666 150.985 18.8691C150.911 18.6715 150.808 18.5028 150.677 18.3629C150.545 18.2189 150.385 18.1078 150.195 18.0214C150.006 17.9391 149.8 17.8938 149.57 17.8938C149.339 17.8938 149.134 17.935 148.948 18.0214C148.763 18.1078 148.607 18.2189 148.479 18.3629C148.352 18.5069 148.249 18.6757 148.175 18.8691C148.101 19.0666 148.068 19.2765 148.068 19.4987C148.068 19.7209 148.105 19.9431 148.175 20.1365C148.249 20.334 148.348 20.5027 148.479 20.6509C148.607 20.799 148.763 20.9143 148.948 20.9966C149.134 21.0789 149.339 21.1241 149.57 21.1241C149.8 21.1241 150.01 21.083 150.195 20.9966C150.385 20.9143 150.545 20.799 150.677 20.6509C150.808 20.5027 150.911 20.334 150.985 20.1365C151.059 19.939 151.096 19.7291 151.096 19.4987Z" fill="#3D4A9F"/>
                <path d="M158.64 22.457V24.2718H156.973V22.457H153.537V20.9674L156.166 16.375H157.981L155.236 21.0291H156.985V18.8605H158.64V21.0291H159.677V22.4529H158.64V22.457Z" fill="#3D4A9F"/>
              </g>
              <defs>
                <clipPath id="clip0_3933_582">
                  <rect width="207.662" height="27.97" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </div>
          <div id="modal_prequalified" style="display: none;" class="modal" v-if="this.show_video">
            <span class="close-button" @click="closeModal">&times;</span>
            <div class="modal-content" v-if="!app_status_declined">
              <!-- <VidalyticsPlayer videoId="4uWuU3X9Le27Sc05" /> -->
               <BunnyCDNVideo  videoId="6a3c2760-a611-4a24-b47f-2c6e9420b589"/>
            </div>
            <div class="modal-content" v-if="app_status_declined">
              <BunnyCDNVideo  videoId="7fac8e60-04e8-4d0f-be50-446c5fa442a1"/>              
              <!-- <VidalyticsPlayer videoId="KBtvUl1CHAppAOtl" /> -->
            </div>
          </div>
        </div>
      </article>
    </div>
    <div v-if="qualified_for_approvals && stage!==''"
      class="tile is-parent"
      style="max-width: 500px; margin: auto; margin-top: 50px"
    >
      <article class="tile is-child box" style>
        <div class="content">
          <h2 style="text-align: center; margin-top: 0px">Congratulations!</h2>
          <div style="text-align: center;">
            <img src="https://cardiff.b-cdn.net/img/DataTransfer.png" width="180px" height="80px"/>
          </div>
          <p style="text-align: center">
            We are procesing your Application.
            <br/>
            {{ stage_message }}
          </p>
          <div>
            <div class="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
          </div>
          
        </div>
      </article>
    </div>
    <div v-if="show_offers">
        <h3 style="margin-top: 0px; padding-left: 15px; text-align: left;font-size: 24px;">You've Pre-Qualify for<br/> a Business Loan</h3>
        <div class="tile is-parent" style=" margin: auto;">
        <article class="tile is-child box">
            <div class="content">
              <h4 class="" style="text-align: left;">Customize your loan:</h4>
              <Slider
                :inputField="inputs.selected_approved_amount"
                inputName="Amount"
                :interval="5000"
                :slider_data = "this.data_slider_approved_amount"
                format="money"
                :marks="test_marks"
                ref="selected_approved_slider"
              />
              <Slider
                :inputField="inputs.selected_terms"
                inputName="Terms"
                :interval="1"
                :slider_data = "this.data_slider_approved_term"
                :marks="true"
                ref="selected_terms_ref"
              />
              <List
                :inputField="inputs.selected_frequency"
                :options="frequency_options"
                inputName="Payment Frequency"
                inputId="frequency"
                :fullWidthOption="false"
              />
              <div class="level is-mobile">
                <div class="level-left" style="font-weight: 500;">
                  Number of payments
                </div>
                <div class="level-right" style="font-weight: 500;">
                  {{ offer.Num_Payments__c }}
                </div>
              </div>
            </div>
        </article>
        </div>
        <div class="buttons is-centered" style="margin-top: 30px;">
          <a class="button is-link padded-button next-button" @click="SelectOffer">Select Offer</a>
        </div>
    </div>
    <div v-if="contract_url" style="">
      <div id="modal_contract" class="modal">
        <div class="modal-content">
          <!-- <span class="close-button">&times;</span> -->
          <iframe :width="iframe_width" :height="iframe_height" :src=this.contract_url ref="iframe" id="iframe" frameborder="0"></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Input from "@/components/shared/Input";
import Slider from "@/components/shared/Slider";
import List from "@/components/shared/List";
import ApplyPage from "@/components/shared/ApplyPage";
// import Checkbox from "@/components/shared/Checkbox";
import MyUtils from "@/utils/MyUtils";

// import VidalyticsPlayer from "@/components/shared/VidalyticsPlayer";
import BunnyCDNVideo from "@/components/shared/BunnyCDNVideo";

import $ from "jquery";
export default {
  name: "ApprovalApply",
  components: {
    // Input,
    Slider,
    List,
    BunnyCDNVideo
    // VidalyticsPlayer
    // Checkbox
  },
  props: {
    texts: Array,
    title: String,
    link: String
  },
  mixins: [ApplyPage],
  data() {
    return {
      initial_message : true,
      qualified_for_approvals :true,
      should_refresh: true,
      requested_amount: 0, 
      offer: {},
      message: "Waiting for updates....",
      show_offers: false,
      inputs: {
        selected_approved_amount: Input.model(),
        selected_terms: Input.model(),
        selected_frequency:  Input.model(),
        smsOptIn: Input.model()
      },
      stage:'',
      stage_message: '',
      frequency_options: [
        "Weekly",
        "Daily"
      ],
      contract_url: '',
      iframe_width: 0,
      iframe_height: 0,
      test_marks:true,
      data_slider_approved_amount : [],
      data_slider_approved_term: [],
      current_date: '',
      show_sms_optin: false,
      app_status_declined : false,
      show_video: true
    };
  },
  mounted: function () {
    console.log("mounted approval.vue");
    console.log('leadid',this.link);
    var self = this;
    setTimeout(function(){
      const modal = $("#modal_prequalified");
      modal.css('display','flex'); // Show the modal
      self.show_video = true;
    }, 3000);

    let requested_amount = MyUtils.getWithExpiry('requested_amount');
    // console.log(" requested_amount: ",requested_amount);
    if(requested_amount){
      this.requested_amount =  "$"+requested_amount;
    }
    let pre_offer_selected = MyUtils.getWithExpiry('pre-offer-selected');
    // console.log("pre_offer_selected: ",pre_offer_selected);
    if(pre_offer_selected){
      this.requested_amount =   `$${Number(pre_offer_selected).toLocaleString('en-US')}` ;;
    }

    let sms_optin_subscribed = MyUtils.getWithExpiry('sms_optin_subscribed');
    // console.log(" sms_optin_subscribed: ",sms_optin_subscribed);
    if(sms_optin_subscribed === false){
      this.show_sms_optin = true;
    }

    let mql_type = MyUtils.getWithExpiry('mql_type');
    console.log(" mql_type: ",mql_type);
    if(mql_type === 'DNQ'){
      this.app_status_declined = true;
    }

    // requested_amount

    let currentDate = new Date();
    this.current_date = this.humanFormatDate(currentDate);
      
    
    if(!this.app_status_declined){
      for (var i = 0; i < 80; i++) {
        create(i);
      }
    }
    

    function create(i) {
      var width = Math.random() * 20;
      var height = width * 0.4;
      var colour = "green";

      $('<div class="confetti-' + i + " " + colour + '"></div>')
        .css({
          width: width + "px",
          height: height + "px",
          top: -Math.random() * 20 + "%",
          left: Math.random() * 80 + "%",
          opacity: Math.random() + 0.5,
          transform: "rotate(" + Math.random() * 360 + "deg)",
        })
        .appendTo("#app");
      drop(i);
    }

    function drop(x) {
      $(".confetti-" + x).animate(
        {
          top: "100%",
          left: "+=" + Math.random() * 15 + "%",
        },
        Math.random() * 3000 + 2000,
        function () {
          $(".confetti-" + x).remove();
        }
      );
    }
    this.checkServerStatus();
    let $heightTest = $("#app-column");
    this.iframe_height =  $heightTest.height() - 120;
    this.iframe_width =  $heightTest.width()- 20;
    if($("body").width() >= 769){
      this.iframe_height =  $("body").height()-250;
    }
  },
  methods :{
      showVideoModal(){
        const modal = $("#modal_prequalified");
        modal.css('display','flex'); // Show the mod
      },
      closeModal() {
        const modal = $("#modal_prequalified");
        modal.css('display','none'); // Hide the modal
      },
      humanFormatDate: function(date) {
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      let month = months[date.getMonth()];
      let day = date.getDate();
      let year = date.getFullYear();

      let hours = date.getHours();
      let minutes = date.getMinutes();
      let ampm = hours >= 12 ? 'pm' : 'am';

      hours = hours % 12 || 12; // Convert 24-hour to 12-hour format
      minutes = minutes.toString().padStart(2, '0'); // Ensure two-digit minutes

      return `${month} ${day}, ${year} ${hours}:${minutes} ${ampm}`;
    },
    checkServerStatus: function(){
      console.log('checkServerStatus');
      const interval = 5000; // seconds
      var self = this;
      async function fetchUpdates() {
        try {
          console.log('fetch Updates');
          console.log('qualified_for_approvals', self.qualified_for_approvals);
            // Call the user-defined validation function to check if polling should stop
            if (!self.should_refresh) {
              console.log("Stopping polling as the condition is met.");
              self.should_refresh = false; // Stop polling
              return;
          }
          $.ajax({
            type: "POST",
            url: "/api/lead/offer_status",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify({
              sf_leadid: self.link,
            }),
          })
            .done(function (response) {
              console.log("response offer_status", response);
              self.initial_message = false;
              self.stage = '';
              if(response.stage && response.stage !=''){
                self.stage = response.stage;
                if(self.stage == 'contracts'){
                  self.stage_message = 'Generating contracts, this could take from 5 to 30 seconds';
                } else if(self.stage == 'plaid_json'){
                  self.stage_message = 'Getting your bank data, this could take a minute or two';
                }
              }
              
              // we will wait for offers
              self.qualified_for_approvals = response.valid;
              self.should_refresh = response.valid;
              // console.log('setting qualified_approvals = response.valid');
              // console.log("response valid", response.valid)
              // console.log("offers", response.offers)
              if(response.offers && response.offers.length > 0){
                self.show_offers = true;
                self.offer = response.offers[0];
                // const start = 5000;
                const start = self.offer.Max_Approval__c;
                const interval = 5000;
                self.data_slider_approved_amount = [];
                let v = start;
                while(v > 0){
                  let d = { id: v , name: v };
                  self.data_slider_approved_amount.push( d );
                  v = v - interval;
                }
                // console.log(self.data_slider_approved_amount);
                const start_term = self.offer.Max_Term__c;
                const interval_term = 1;
                self.data_slider_approved_term = [];
                let i = start_term;
                while(i > 0){
                  let d = { id: i , name: i };
                  // console.log(d);
                  self.data_slider_approved_term.push( d );
                  i = i - interval_term;
                }
                setTimeout(function(){
                  self.$refs.selected_approved_slider.initialSelectedValue(self.offer.Max_Approval__c);
                  self.$refs.selected_terms_ref.initialSelectedValue(self.offer.Max_Term__c);
                  $('#Weekly').trigger('click');
                },1000);
                self.should_refresh = false;
              }

              if(response.contract_url && response.contract_url !==''){
                self.contract_url = response.contract_url;
                self.should_refresh = false;
                setTimeout(function(){
                  const modal = $("#modal_contract");
                  modal.css('display','flex'); // Show the modal
                },3000);
              }
              
            })
            .fail(function (err) {
              console.log(err.responseText);
              self.invalid = true;
            });
            console.log("Valid response, continuing to poll");
        } catch (error) {
            console.error("Error fetching updates:", error);
        }
        // Schedule the next polling if not stopped
        if (self.should_refresh) {
            setTimeout(fetchUpdates, interval);
        }
      }
      fetchUpdates();
    },
    SelectOffer:function(){
      let self = this;
      console.log('select offer!');
      if (!self.validateInPlace()) {
        console.log("not sending any request until this is valid");
        self.clicked = false;
        return;
      }
      $.ajax({
        type: "POST",
        url: "/api/lead/select_offer",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify({
          sf_leadid: self.link,
          selected_terms : self.inputs.selected_terms.value,
          selected_approved_amount : self.inputs.selected_approved_amount.value,
          selected_frequency : self.inputs.selected_frequency.value,
        }),
      })
        .done(function (response) {
          // console.log("response offer_status", response);
          self.should_refresh = true;
          self.show_offers = false;
          self.checkServerStatus();
        })
        .fail(function (err) {
          console.log(err.responseText);
          self.invalid = true;
        });
    },
    submit_SMS_OptIn: function(){
      let self = this;
      $.ajax({
        type: "POST",
        url: "/api/lead/select_notify_me",
        contentType: "application/json",
        dataType: "json",
        data: JSON.stringify({
          sf_leadid: self.link,
          notify_me : true
        }),
      })
      .done(function (response) {
        $('#notification_subscribed').show('slow');
        setTimeout(function(){
          $('#notification_subscribed').hide('slow');
        },10000);
      })
      .fail(function (err) {
        console.log(err.responseText);
      });
    } 
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
[class|="confetti"] {
  position: absolute;
}
.green {
  background-color: #3cb968;
}
.level {
  margin-bottom: 10px !important;
}
#check {
  max-width: 20%;
  margin: auto;
  display: block;
}
#approval_checkbox_sms .choice p{
font-size: 8px!important;
text-align: justify;
text-justify: inter-word;
line-height: 15px;
}
#approval_checkbox_sms .choice{
padding-left: 10px;
padding-right: 10px;
background-color: #E0FFFF;
border-radius: 8px;
}
#approval_checkbox_sms .columns{
align-items: normal;
}
</style>
<style lang="scss" scoped>
.box{
  border-radius: 29px;
  background: #FFF;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
   padding: 2.1rem;
}
.border{
  border-bottom: 1px solid #A09F9F;
// box-shadow: 0px 24px 3px -24px magenta;

// width   : 200px;
// height  : 50px;
position: relative;
z-index : 1;
// background: #eee;
// padding-bottom: 12px;

}
.border::after{
  content : "";
  position: absolute;
  left    : 5%;
  bottom  : 0;
  height  : 1px;
  width   : 90%;  /* or 100px */
  border-top:1px solid white;
}
.summary_divider{
  width: 236px;
  height: 1px;
  background: #FFF;
  margin: 0 auto;
}
.small-input{
width: 80%;
}
#summary_table{
  // display: flex;
  // width: 260px;
  // padding: 12px;
  // flex-direction: column;
  // align-items: center;
  // gap: 8px;

  flex-direction: column;
  justify-content: flex-start;
  // align-items: center;
  // gap: 8px;
  display: inline-flex;

  border-radius: 8px;
  // background: #E9F6EC;
}
.summary_row{
  // display: ruby;
  width: 260px;
  // padding-top: 12px;
  padding-left: 12px;
  padding-right: 12px;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 11px;
}
.left_column{
  text-align: left;
  color: #666;
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;
  // display: inline-block;
  float: left;
}
.right_column{
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal; /* 158.333% */
  text-align: right;
  color: #000;
  font-family: Roboto;
  float: right;
}
#status_pending{
  width: 82px;
  height: 27px; 
  border-radius: 4px;
  background: #FFF;
  display: inline-flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 10px;
}
.notes_next{
  color: #666;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px; /* 135.714% */
}

.icon_container{
  text-align: center;
  margin-bottom: 21px;
  margin-top: -65px;
}
.subtitle_approval{
  color: #666;
  text-align: center;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px; /* 118.75% */
}
.cardiff_word{
  color: #3A67D2;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 19px;
}
#decline-message{
  color: #666;
  text-align: center;
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 45px;
}
.lds-spinner,
.lds-spinner div,
.lds-spinner div:after {
  box-sizing: border-box;
}
.lds-spinner {
  color: currentColor;
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;

  margin: 0 auto;
  display: block;
}
.lds-spinner div {
  transform-origin: 40px 40px;
  animation: lds-spinner 1.2s linear infinite;
}
.lds-spinner div:after {
  content: " ";
  display: block;
  position: absolute;
  top: 3.2px;
  left: 36.8px;
  width: 6.4px;
  height: 17.6px;
  border-radius: 20%;
  background: currentColor;
}
.lds-spinner div:nth-child(1) {
  transform: rotate(0deg);
  animation-delay: -1.1s;
}
.lds-spinner div:nth-child(2) {
  transform: rotate(30deg);
  animation-delay: -1s;
}
.lds-spinner div:nth-child(3) {
  transform: rotate(60deg);
  animation-delay: -0.9s;
}
.lds-spinner div:nth-child(4) {
  transform: rotate(90deg);
  animation-delay: -0.8s;
}
.lds-spinner div:nth-child(5) {
  transform: rotate(120deg);
  animation-delay: -0.7s;
}
.lds-spinner div:nth-child(6) {
  transform: rotate(150deg);
  animation-delay: -0.6s;
}
.lds-spinner div:nth-child(7) {
  transform: rotate(180deg);
  animation-delay: -0.5s;
}
.lds-spinner div:nth-child(8) {
  transform: rotate(210deg);
  animation-delay: -0.4s;
}
.lds-spinner div:nth-child(9) {
  transform: rotate(240deg);
  animation-delay: -0.3s;
}
.lds-spinner div:nth-child(10) {
  transform: rotate(270deg);
  animation-delay: -0.2s;
}
.lds-spinner div:nth-child(11) {
  transform: rotate(300deg);
  animation-delay: -0.1s;
}
.lds-spinner div:nth-child(12) {
  transform: rotate(330deg);
  animation-delay: 0s;
}
@keyframes lds-spinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
#cardiff-logo-2004{
 margin-top: 24px;
 text-align: center; 
}
#notification_subscribed{
  display: none;
  margin-bottom: 10px;
  text-align: center;
}
.show-video-link{
    width: 50%;
    text-align: center;
    
    margin: 0 auto;
    margin-bottom: 82px;
    // border: 1px solid #3A67D2;
    height: 135px;
    width:  270px;
    vertical-align: middle;
    border-radius: 4px;
    // padding-top: 9px;
    
    color: var(--Color-CTA, #3A67D2);
    text-align: center;
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}
/* Modal container (hidden by default) */
.modal {
    display: none; /* Hidden by default */
    position: fixed; /* Stay in place */
    top: 0;
    left: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgba(0, 0, 0, 0.67); /* Black background with opacity */
    z-index: 1000; /* Sit on top */
    justify-content: center; /* Center the modal */
    align-items: center; /* Center the modal */
}

/* Modal content */
.modal-content {
    // background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    text-align: center;
    width: 80%; /* Default width */
    // max-width: 500px; /* Max width */
}
.prequalified_status{
  color: #28A745;
}
.declined_status{
  color: red;
}
@media (max-width: 47.999em) {
  .modal-content {
    width: 100%; /* Default width */
  }
  .subtitle_approval{
    font-size: 14px;
  }
  .cardiff_word{
    font-size: 14px;
  }
  #status_pending{
    width: auto;
  }
}

/* Close button */
.close-button {
    position: absolute;
    top: 10px;
    right: 5%;
    font-size: 30px;
    font-weight: bold;
    cursor: pointer;
    color: white;
}

.close-button:hover {
  color: black;
}
</style>